import { render } from "./FavoriteButton.vue?vue&type=template&id=2dd3d0aa&scoped=true&ts=true"
import script from "./FavoriteButton.vue?vue&type=script&lang=ts"
export * from "./FavoriteButton.vue?vue&type=script&lang=ts"

import "./FavoriteButton.vue?vue&type=style&index=0&id=2dd3d0aa&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd3d0aa"]])

export default __exports__